/************************************** THIRD-PARTY MODULES ***************************************/
import React from 'react';
import {omit} from 'mad-utils/lib/react';

/********************************************* EXPORT *********************************************/
/**
 * Image with baseline props (adds empty alt text).
 *
 * See https://webaim.org/techniques/alttext/
 */
export const Img = (props: Html.ImgElement.attributes) => {
    return <img alt={props.alt || ''} {...omit(props, ['children', 'alt'])} />;
};

Img.displayName = `Img`;
